import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion"
import { BarLoader } from 'react-spinners';

import { Fonts } from '../theme/fonts';
import { Containers } from './../theme/containers';
import { Styling } from '../theme/styling';
import { Images } from '../../assets/img';
import { ThemeContext } from '../darkmode/themeContext';
// import { Spacing } from '../theme/spacing';


export const Intro = ({ readmoreActive }) => {
    const { theme } = React.useContext(ThemeContext);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1200)
    }, [])

    const logoSize = `
    mx-auto mb-6 opacity-100 dark:opacity-80
    2xsm:w-44 
    md:w-52
    2xl:w-60

    `

    return (
        <>
            <div>
                {
                    loading ?
                        <div className={`${Containers.introContainer} justify-center ${readmoreActive ? '' : 'min-h-[600px]'}`}>
                            {theme === 'dark' ? (
                                <BarLoader
                                    color={'hsl(207, 100%, 65%)'}
                                    loading={loading}
                                    // css={override}
                                    size={50}
                                    speedMultiplier='0.9'
                                />
                            ) : (
                                <BarLoader
                                    color={'hsl(211, 100%, 18%)'}
                                    loading={loading}
                                    // css={override}
                                    size={50}
                                    speedMultiplier='0.9'
                                />
                            )}
                        </div>
                        :
                        <div key={1} className="relative z-20 h-full">
                            <div className={`${Containers.carouselSubContainer} ${Styling.flexX} ${readmoreActive ? '' : 'min-h-[600px]'}`}>
                                <motion.div
                                    transition={{
                                        duration: 1.2,
                                        ease: "easeInOut"
                                    }}
                                    exit={{
                                        opacity: 0
                                    }}
                                    animate={{
                                        opacity: 1,
                                        y: 0
                                    }}
                                    initial={{
                                        opacity: 0,
                                        y: 0
                                    }}
                                >
                                    {theme === 'dark' ? (
                                        <img src={Images.logoDrk} alt="ResolYou Conflict Resolution" className={`${Containers.logoSize}`} />
                                    ) : (
                                        <img src={Images.logo} alt="ResolYou Conflict Resolution" className={`${Containers.logoSize}`} />
                                    )}
                                    <h1 className={`${Fonts.titleFont} opacity-90`}>Conflict Resolution
                                        <br />
                                        <span className='text-secondaryDark dark:text-gray-50'>Resolyou</span><strong className="text-lightishSecondary dark:text-lightSecondary">.org</strong>
                                    </h1>
                                </motion.div>
                            </div>
                        </div>
                }
            </div>
        </>
    )
}